import PropTypes from 'prop-types';
import React from 'react';

import { Icon } from 'Icons';
import { FAIcon } from 'lib/customPropTypes';

import './styles.css';

//
// TODO: Deprecate and remove this component. Too much overhead for a simple CSS class change.
//
const ListStepped = ({ children, className }) => (
  <ol className={`step-list ${className}`}>{children}</ol>
);

ListStepped.defaultProps = {
  className: '',
};

ListStepped.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

//
// TODO: Deprecate and remove this component. Too much overhead for a simple CSS class change.
//
const ListUnstyled = ({ children, className }) => (
  <ul className={`pl-0 list-none ${className}`}>{children}</ul>
);

ListUnstyled.defaultProps = ListStepped.defaultProps;
ListUnstyled.propTypes = ListStepped.propTypes;

//
// TODO: Deprecate and remove this component. Too much overhead for a simple CSS class change.
//
const IconListItem = ({ children, icon, iconAlt, ...rest }) => (
  <li {...rest}>
    {icon && <Icon alt={iconAlt} className="mr-2" fixedWidth icon={icon} />}
    {children}
  </li>
);

IconListItem.defaultProps = {
  icon: null,
  iconAlt: '',
};

IconListItem.propTypes = {
  children: PropTypes.node.isRequired,
  icon: FAIcon,
  iconAlt: PropTypes.string,
};

//
// TODO: Deprecate and remove this component. Too much overhead for something that can easily be done in raw HTML.
//
const IconList = ({ as: Component, children, className, icon, ...rest }) => {
  const childrenWithIcons = React.Children.map(children, (child) => {
    if (!icon && !child.props.icon) {
      throw new Error(
        'an `icon` prop must be passed to either the `IconList` or `IconListItem` component.',
      );
    }

    // If the ListItem has an `icon` prop, use it.
    return child.props.icon ? child : React.cloneElement(child, { icon });
  });
  return (
    <Component className={`list-none ${className}`} {...rest}>
      {childrenWithIcons}
    </Component>
  );
};

IconList.defaultProps = {
  as: 'ul',
  children: null,
  className: '',
  icon: null,
};

IconList.propTypes = {
  as: PropTypes.oneOf(['ol', 'ul']),
  children: PropTypes.node,
  className: PropTypes.string,
  icon: FAIcon,
};

export { IconList, IconListItem, ListStepped, ListUnstyled };
